// در فایل App.js - نسخه نهایی بدون خطای eslint
import {
  BrowserRouter as Router,
  Route,
  Routes,
  Navigate,
  Outlet,
} from "react-router-dom";
import "./App.css";
import { Context, Provider } from "./context/Context";
import HomePage from "./pages/HomePage";
import SettingPage from "./pages/SettingsPage";
import PlanningPage from "./pages/PlanningPage";
import DevicesPage from "./pages/DevicesPage";
import ProfilePage from "./pages/ProfilePage";
import AboutUsPage from "./pages/AboutUsPage";
import LoginPage from "./pages/LoginPage";
import BackupManagementPage from "./pages/BackupManagmentPage";
import React, { useContext, useEffect, useRef } from "react";
import DimmerPage from "./pages/Dimmer";
import FanCoilPage from "./pages/FanCoilPage";
import KeyPage from "./pages/KeyPage";
import MotorPage from "./pages/Motor";
import RemotePage from "./pages/RemotePage";
import ScenarioKeyPage from "./pages/ScenarioKeyPage";
import TelevisionPage from "./pages/TelevisionPage";
import ThermostatPage from "./pages/Thermostat";
import WirelessKeyPage from "./pages/WirelessKeyPage";
import SelectDevicePage from "./pages/SelectDevicePage";
import ScenarioPage from "./pages/ScenarioPage";
import ScenarioListPage from "./pages/ScenarioListPage";
import SchedulePage from "./pages/SchedulePage";
import { MqttProvider } from "./context/MQTTContext";
import HumidityPage from "./pages/HumidityPage";
import RGBPage from "./pages/RGBPage";
import InputPage from "./pages/InputPage";
import { EquipmentsProvider } from "./context/Equipments";
import InputStatusPage from "./pages/InputStatusPage";
import DataLoggerPage from "./pages/DataLoggerPage";
import VerifyPaymentPage from "./pages/VerifyPaymentPage";
import ReChargeWallet from "./pages/ReChargeWallet";
import HelpPage from "./pages/HelpPage";
import Layout from "./layouts/Layout";

const MODAL_CLOSE_EVENT = 'close-all-modals';

// تابع قطعی برای بستن همه مودال‌ها و حذف کامل backdrop
const closeAllModals = () => {
  // 1. بستن همه مودال‌ها با استفاده از Bootstrap API
  if (window.bootstrap && window.bootstrap.Modal) {
    const allModals = document.querySelectorAll('.modal');
    allModals.forEach(modalElement => {
      try {
        const modalInstance = window.bootstrap.Modal.getInstance(modalElement);
        if (modalInstance) {
          modalInstance.hide();
        }
      } catch (e) {
        // خطا را نادیده بگیر
      }
    });
  }

  // 2. بستن دستی همه مودال‌ها (روش پشتیبان)
  const modals = document.querySelectorAll('.modal');
  modals.forEach(modal => {
    // حذف کلاس‌های نمایش
    modal.classList.remove('show', 'in', 'fade');
    modal.style.display = 'none';
    modal.setAttribute('aria-hidden', 'true');
    modal.removeAttribute('aria-modal');
    modal.removeAttribute('role');
    
    // پیدا کردن دکمه بستن و کلیک کردن روی آن
    const closeBtn = modal.querySelector('[data-bs-dismiss="modal"]');
    if (closeBtn) {
      closeBtn.click();
    }
  });

  // 3. حذف کامل همه backdropها (مهم‌ترین بخش)
  const backdrops = document.querySelectorAll('.modal-backdrop');
  backdrops.forEach(backdrop => {
    backdrop.remove(); // حذف کامل از DOM
  });

  // 4. پاکسازی کلاس‌های body
  document.body.classList.remove('modal-open');
  document.body.style.overflow = '';
  document.body.style.paddingRight = '';
  document.body.style.position = '';
  document.body.style.top = '';
  document.body.style.width = '';
  
  // 5. حذف هر گونه استایل padding-right از عناصر
  const allElements = document.querySelectorAll('[style*="padding-right"]');
  allElements.forEach(el => {
    if (el.style.paddingRight === '0px' || el.style.paddingRight === '0' || el.style.paddingRight === '') {
      el.style.paddingRight = '';
    }
  });
  
  // 6. حذف کلاس modal-open از هر عنصر دیگری
  const modalOpenElements = document.querySelectorAll('.modal-open');
  modalOpenElements.forEach(el => {
    el.classList.remove('modal-open');
  });
  
  // 7. اطمینان از قابل اسکرول بودن body
  document.body.style.overflow = 'auto';
  document.documentElement.style.overflow = 'auto';
  
  // 8. دیسپچ رویداد برای اطلاع به کامپوننت‌ها
  window.dispatchEvent(new CustomEvent(MODAL_CLOSE_EVENT));
  
  // 9. ری کردن مجدد صفحه (force reflow) - بدون خطای eslint
  void document.body.offsetHeight; // force reflow
};

const PrivateRoutes = () => {
  const { authUser } = useContext(Context);

  if (!authUser) {
    return <Navigate to="/login" replace />;
  }

  return <LayoutWrapper />;
};

const SelectListAccess = () => {
  const { selectedEquipment } = useContext(Context);
  return <Outlet />;
};

const LayoutWrapper = () => {
  return (
    <Layout>
      <Outlet />
    </Layout>
  );
};

function App() {
  useEffect(() => {
    let isHandlingBack = false;
    
    const handleBackButton = (event) => {
      // جلوگیری از اجرای همزمان چندباره
      if (isHandlingBack) {
        event.preventDefault();
        return;
      }
      
      // بررسی وجود هر مودال باز (چندین روش بررسی)
      const anyModalOpen = document.querySelector('.modal.show, .modal.in, [role="dialog"].show, .modal[style*="display: block"]');
      const hasBackdrop = document.querySelector('.modal-backdrop');
      
      if (anyModalOpen || hasBackdrop) {
        isHandlingBack = true;
        
        // بستن همه مودال‌ها
        closeAllModals();
        
        // جلوگیری از ناوبری به صفحه قبل
        event.preventDefault();
        event.stopPropagation();
        
        // اضافه کردن state به history برای جلوگیری از بازگشت
        window.history.pushState(null, '', window.location.pathname);
        
        // ریست flag بعد از اتمام عملیات
        setTimeout(() => {
          isHandlingBack = false;
        }, 200);
      }
    };

    // اضافه کردن event listener برای دکمه بک
    window.addEventListener("popstate", handleBackButton);
    
    // اضافه کردن state اولیه برای مدیریت بک
    window.history.pushState(null, '');

    return () => {
      window.removeEventListener("popstate", handleBackButton);
    };
  }, []);

  return (
    <Provider>
      <MqttProvider>
        <Router>
          <Routes>
            <Route path="/login" element={<LoginPage />} />
            <Route path="/ch" element={<ReChargeWallet />} />
            <Route path="/verify-payment" element={<VerifyPaymentPage />} />

            <Route element={<PrivateRoutes />}>
              <Route path="/" element={<HomePage />} />
              <Route path="/:room_id" element={<HomePage />} />
              <Route path="/room/:room_id" element={<HomePage />} />
              <Route path="/planning" element={<PlanningPage />} />
              <Route
                path="/planning/scenario-list"
                element={<ScenarioListPage />}
              />
              <Route
                path="/planning/scenario/:scenario_id"
                element={<ScenarioPage />}
              />
              <Route element={<SelectListAccess />}>
                <Route
                  path="/room/select-device/:room_id/:equipment_id/:equipment_type"
                  element={<SelectDevicePage />}
                />
              </Route>
              <Route path="/planning/schedule" element={<SchedulePage />} />
              <Route path="/devices" element={<DevicesPage />} />
              <Route path="/settings" element={<SettingPage />} />
              <Route path="/profile" element={<ProfilePage />} />
              <Route
                path="/settings/backup-management"
                element={<BackupManagementPage />}
              />
              <Route path="/settings/help" element={<HelpPage />} />
              <Route path="/settings/about-us" element={<AboutUsPage />} />

              <Route
                path="/room/dimmer/:room_id/:equipment_id/:equipment_type"
                element={<DimmerPage />}
              />
              <Route
                path="/room/rgb/:room_id/:equipment_id/:equipment_type"
                element={<RGBPage />}
              />
              <Route
                path="/room/fan-coil/:room_id/:equipment_id/:equipment_type"
                element={<FanCoilPage />}
              />
              <Route
                path="/room/key/:room_id/:equipment_id/:equipment_type"
                element={<KeyPage />}
              />
              <Route
                path="/room/motor/:room_id/:equipment_id/:equipment_type"
                element={<MotorPage />}
              />
              <Route
                path="/room/remote/:room_id/:equipment_id/:equipment_type"
                element={<RemotePage />}
              />
              <Route
                path="/room/scenario-key/:room_id/:equipment_id/:equipment_type"
                element={<ScenarioKeyPage />}
              />
              <Route
                path="/room/television/:room_id/:equipment_id/:equipment_type"
                element={<TelevisionPage />}
              />
              <Route
                path="/room/thermostat/:room_id/:equipment_id/:equipment_type"
                element={<ThermostatPage />}
              />
              <Route
                path="/room/humidity/:room_id/:equipment_id/:equipment_type"
                element={<HumidityPage />}
              />
              <Route
                path="/room/wireless-key/:room_id/:equipment_id/:equipment_type"
                element={<WirelessKeyPage />}
              />
              <Route
                path="/room/input/:room_id/:equipment_id/:equipment_type"
                element={<InputPage />}
              />
              <Route
                path="/room/input-status/:room_id/:equipment_id/:equipment_type"
                element={<InputStatusPage />}
              />
              <Route
                path="/room/data-logger/:room_id/:equipment_id/:equipment_type"
                element={<DataLoggerPage />}
              />
            </Route>
          </Routes>
        </Router>
      </MqttProvider>
    </Provider>
  );
}

export default App;